import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import {
  Avatar,
  Button,
  TextField,
  CssBaseline,
  Typography,
  Container,
  Box,
  Alert,
  Stack,
  Paper,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import swal from "sweetalert";

const ConferenceRestPassword = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
const [disabled, setDisabled] = useState(false);
  const keyId = document.URL.split("/").slice(-1)[0];

  const [resetPassword, setResetPassword] = useState({
    newPassword: "",
    confirmPassword: "",
    error_list: {},
  });

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`api/conference-forgot/password/VerifyEmail?id=${keyId}`)
      .then((res) => {
        if (res.status === 200 && res.data.status === true) {
          setShowForm(true);
        } else {
          setShowForm(false);
        }
      })
      .catch(() => setShowForm(false))
      .finally(() => setLoading(false));
  }, [keyId]);

  const handleInput = (e) => {
    setResetPassword({ ...resetPassword, [e.target.name]: e.target.value });
  };

  const conformPassword = (e) => {
    e.preventDefault();
    const data = {
      newPassword: resetPassword.newPassword,
      confirmPassword: resetPassword.confirmPassword,
      keyId,
    };
setDisabled(true);
    axios.get("/sanctum/csrf-cookie").then(() => {
      axios.post(`/api/conference/update/password`, data).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          setDisabled(false);
          history.push("/conference-participant-login");
        } else if ([401, 402, 403, 404, 405].includes(res.data.status)) {
          swal("Error", res.data.message, "error");
           setDisabled(false);
        } else {
          setResetPassword({
            ...resetPassword,
            error_list: res.data.validate_error || {},
        
          });
          setDisabled(false);
        }
      });
    });
  };

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          mt: { xs: 6, sm: 8 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {showForm ? (
          <Paper
            elevation={6}
            sx={{
              p: { xs: 3, sm: 5 },
              borderRadius: 3,
              width: "100%",
              maxWidth: 450,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
                <LockResetIcon fontSize="large" />
              </Avatar>
              <Typography component="h1" variant="h5" fontWeight="bold">
                Reset Your Password
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                align="center"
                sx={{ mt: 1 }}
              >
                Please enter your new password below to secure your account.
              </Typography>
            </Box>

            <Box component="form" onSubmit={conformPassword} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                name="newPassword"
                label="New Password"
                type="password"
                onChange={handleInput}
                value={resetPassword.newPassword}
                error={!!resetPassword.error_list?.newPassword}
                helperText={resetPassword.error_list?.newPassword}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                onChange={handleInput}
                value={resetPassword.confirmPassword}
                error={!!resetPassword.error_list?.confirmPassword}
                helperText={resetPassword.error_list?.confirmPassword}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={disabled}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.5,
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Update Password
              </Button>
            </Box>
          </Paper>
        ) : (
          <Stack sx={{ width: "100%", mt: 12 }} spacing={2}>
            <Alert severity="error" variant="filled">
              Invalid or expired password reset link!
            </Alert>
          </Stack>
        )}
      </Box>
    </Container>
  );
};

export default ConferenceRestPassword;
